import 
    {   basicProps, 
        subMenuProps,
        subMenuSubCategoryProps,
        suggestedInventoryExpenseSheetProps, 
        finalFoodProps } from './properties'

export const setFoodMenuProfileInfo = (state, payload) => {

    state.props.id = payload.id
    state.props.menu_title = payload.menu_title
    state.props.sales_price = payload.sales_price
    state.props.suggested_base_price = payload.suggested_base_price
    state.props.suggested_profit_percent = payload.suggested_profit_percent
    state.props.suggested_sales_price = payload.suggested_sales_price
    state.props.banner_image = payload.banner_image
    state.props.availability = payload.availability
    state.props.sub_menus = JSON.parse(payload.sub_menus)
    
    if(state.props.sub_menus == null || state.props.sub_menus.length == 0) {
        state.props.sub_menus = [JSON.parse(JSON.stringify(subMenuProps))]
    }

}

export const setFoodMenuList = (state, payload) => {
    state.list = payload
}

export const setFoodMenuId = (state, payload) => {
    state.props.id = payload.id
}

export const setFoodMenuSubMenuListItem = state => {

    state.props.sub_menus.push(JSON.parse(JSON.stringify(subMenuProps)))

    let indexNum = 0
    state.props.sub_menus.forEach(element => {
        element.key = indexNum
        indexNum ++
    })
    
}

export const resetFoodMenuSubMenuListItem = state => {
    
    let indexNum = 0
    state.props.sub_menus.forEach(element => {
        element.key = indexNum
        indexNum ++
    })
    
}

export const setFoodMenuSubMenuCategoryListItem = (state, paylodIndex) => {
    state.props.sub_menus[paylodIndex].sub_category.push(JSON.parse(JSON.stringify(subMenuSubCategoryProps)))

    let indexNum = 0
    state.props.sub_menus[paylodIndex].sub_category.forEach(element => {
        element.key = indexNum
        indexNum ++
    })
    
}

export const resetFoodMenuSubMenuCategoryListItem = (state, paylodIndex) => {
    
    let indexNum = 0
    state.props.sub_menus[paylodIndex].sub_category.forEach(element => {
        element.key = indexNum
        indexNum ++
    })
    
}

export const setFoodMenuExpenseListItem = (state, payload) => {
    state.props.sub_menus[payload.main_index].sub_category[payload.sub_index].suggested_inventory_expense_sheet.push(JSON.parse(JSON.stringify(suggestedInventoryExpenseSheetProps)))

    let indexNum = 0
    state.props.sub_menus[payload.main_index].sub_category[payload.sub_index].suggested_inventory_expense_sheet.forEach(element => {
        element.key = indexNum
        indexNum ++
    })
    
}

export const setFinalFoodList = (state, payload) => {
    state.final_list = payload
}

export const resetFinalFoodList = state => {
    state.final_list = [JSON.parse(JSON.stringify(finalFoodProps))]
}

export const resetFoodMenuExpenseListItem = (state, payload) => {
    
    let indexNum = 0
    state.props.sub_menus[payload.main_index].sub_category[payload.sub_index].suggested_inventory_expense_sheet.forEach(element => {
        element.key = indexNum
        indexNum ++
    })
    
}

export const resetFoodMenuForm = state => {
    state.props = JSON.parse(JSON.stringify(basicProps))
}

export const setMenuEdit = (state, payload) => {
    console.log('HERE')
    state.menu_edit = payload
}


// WEBPACK FOOTER //
// ./src/store/modules/foodMenus/mutations.js